import type { FormValidationState } from '@react-stately/form';
import { createContext } from 'react';

/** @internal */
export interface ToggleButtonGroupContextValue {
  form?: string;
  name?: string;
  isInvalid?: boolean;
  isRequired?: boolean;
  validationState: FormValidationState;
}

/** @internal */
export const ToggleButtonGroupContext = createContext<ToggleButtonGroupContextValue | null>(null);
